<template>
    <div class="p-3">
        <h3>Merge Data Pasien</h3>
        <hr />

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label
                        for="tanggal_dari"
                        class="col-sm-4 col-form-label text-end"
                    >
                        Dari
                    </label>

                    <div class="col-sm-8">
                        <input
                            type="date"
                            name="tanggal_dari"
                            id="tanggal_dari"
                            class="form-control"
                            v-model="filter.tanggal_dari"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label
                        for="tanggal_sampai"
                        class="col-sm-4 col-form-label text-end"
                    >
                        Sampai
                    </label>

                    <div class="col-sm-8">
                        <input
                            type="date"
                            name="tanggal_sampai"
                            id="tanggal_sampai"
                            class="form-control"
                            v-model="filter.tanggal_sampai"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label
                        for="search"
                        class="col-sm-6 col-form-label text-end"
                    >
                        No. RM/Nama/NIK/No Kartu BPJS
                    </label>

                    <div class="col-sm-6">
                        <input
                            type="text"
                            name="search"
                            id="search"
                            class="form-control"
                            v-model="filter.search"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters">
                            <i class="fa fa-refresh"></i>
                            Reset
                        </button>

                        <button class="btn btn-primary" @click="getAllPasien">
                            <i class="fa fa-search"></i>
                            Cari
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Pasien</div>

            <div class="card-body">
                <div id="table-pasien"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from "tabulator-tables";

export default {
    data() {
        return {
            master_pasiens: [],

            filter: {
                tanggal_dari: "",
                tanggal_sampai: "",
                search: "",
                page: 1,
            },

            table: null,
        };
    },

    created() {
        this.filter.page = this.$route.query.page ?? 1;
    },

    mounted() {
        this.getAllPasien();
    },

    methods: {
        getAllPasien() {
            const uri = `/api/merge-pasien/get-all-pasien?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&search=${this.filter.search}`;

            const element = document.getElementById("table-pasien");

            if (this.table) {
                this.table.destroy();
                this.table = null;
            }

            this.table = new Tabulator(element, {
                layout: "fitColumns",

                pagination: true,
                paginationMode: "remote",
                paginationSize: 10,
                paginationSizeSelector: [10, 25, 50, 100],

                dataLoader: this.ajaxLoader,

                ajaxURL: uri,

                ajaxResponse: this.AjaxResponse,

                sortMode: "remote",
                filterMode: "remote",

                columns: [
                    {
                        title: "No Rekam Medis",
                        field: "Medrec",
                    },
                    {
                        title: "Nama",
                        field: "Firstname",
                    },
                    {
                        title: "Tanggal Lahir",
                        field: "Bod",
                    },
                    {
                        title: "NIK",
                        field: "NoIden",
                    },
                    {
                        title: "No Kartu BPJS",
                        field: "AskesNo",
                    },
                    {
                        title: "Tanggal Daftar",
                        field: "tgl_daftar",
                    },
                    {
                        title: "Action",
                        formatter: function () {
                            return '<button class="btn btn-sm btn-primary">Detail</button>';
                        },
                        cellClick: this.openDetailPage,
                    },
                ],
            });
        },

        ajaxLoader() {
            // set loading screen
        },

        AjaxResponse(url, params, response) {
            return response.master_pasiens;
        },

        openDetailPage(e, cell) {
            const data = cell.getRow().getData();
            const medrec = data.Medrec;

            this.$router.push({
                name: "merge_pasien_details",
                params: {
                    Medrec: medrec,
                },
            });
        },

        resetFilters() {
            this.filter = {
                tanggal_dari: "",
                tanggal_sampai: "",
                search: "",
                page: 1,
            };

            this.getAllPasien();
        },
    },
};
</script>
